<div class="modal-header super-compos-modal-header">
     <h4 class="modal-title super-compos-modal-title">
          <span
               class="noItalic super-compos-modal-title super-compos-modal-title-span">{{'duplicate.duplicationManagement'|translate}}</span>
     </h4>
     <div class="d-flex justify-content-end">
          <super-button styleClass="blue" (click)="ref.close(false);" [text]="'btn.cancel'|translate"></super-button>
          <super-button styleClass="green ms-3" (click)="submitDuplicationManagement($event)" text="Confirmer"></super-button>
     </div>
</div>
<div class="modal-body">
     <section [formGroup]="formDuplicationPoint">
          <div class="row" *ngIf="duplicationManagementIndex ===0">
               <!-- 1st part of the modal directly accessed when its opened -->
               <div class="col-12 mb-2 mt-2">
                    <p-checkbox [label]="'duplicate.pointContent'|translate" binary="true"
                         formControlName="infos"></p-checkbox>
               </div>
               <div class="col-12 mb-2" *ngIf="filesForDuplication.length >0">
                    <p-checkbox [label]="'duplicate.filesSelection'|translate" binary="true"
                         formControlName="files"></p-checkbox>
               </div>
               <div class="col-12">
                    <p-checkbox [label]="'duplicate.recipients'|translate" binary="true"
                         formControlName="recipients"></p-checkbox>
               </div>
          </div>
          <div class="row" *ngIf="duplicationManagementIndex ===1">
               <!-- 2nd part of the modal accessed when the user chose to add files to the duplication-->
               <div class="col-12">
                    <super-table [initialSelection]="filesForDuplication" [forselectionDefaultOption]="false"
                         #superTableFilesDuplication [forselection]="null"
                         [items]="filesForDuplication|sort:'OrdreAffichage':'ASC'" [columns]="columnsFiles"
                         id="super-files-tables-Duplications" [height]="'calc( 100vh - 400px)'" [multiselect]="true">
                    </super-table>
               </div>
          </div>
     </section>
</div>


<p-sidebar [(visible)]="modalPdfViewer" position="right" [style]="{width:'50vw'}">
     <section>
          <i-viewer *ngIf="blobViewer" [file]="currentFileForViewer" [viewerConfig]="pdfViewerConfig"
               style="height: 100vh; display: block;">
          </i-viewer>
     </section>
</p-sidebar>